export default {
  PleaseLoginFirst: 'Login first',
  IdentityExpired: 'Identity expired, please login again',
  InsufficientBalance: 'Your balance is insufficient, please click the avatar in the upper right corner to go to "My Account" to check',
  ImageGenerationFailed: 'Image generation failed, please check the prompt parameters or content',
  TaskNotFound: 'Task not found, please try again or contact customer service',
  ServiceUnavailable: 'Current service is unavailable, please try again or contact customer service',
  PleaseWaitForCurrentTask: 'Please wait for the current task to complete',
  ImageGenerationIssue: 'There was a small issue with image generation, please try again',
  UnknownError: 'Unknown error, please try again or contact customer service',
  NetworkIssue: 'Network encountered some problems, please click refresh or contact customer service',
  Refresh: 'Refresh',
  RequestCancelled: 'Request cancelled'
}